var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.575 6.07959C9.37412 6.07959 5.96875 9.49409 5.96875 13.706C6.3694 23.8224 20.7821 23.8195 21.1813 13.7059C21.1813 9.49409 17.7758 6.07959 13.575 6.07959ZM13.575 18.0733C11.1673 18.0733 9.20822 16.1144 9.20822 13.7065C9.32672 10.7181 11.5548 9.3615 13.5749 9.3615H13.5752C15.5954 9.36166 17.8237 10.7183 17.9415 13.6968C17.9418 16.1146 15.9828 18.0733 13.575 18.0733Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5766 9.85889C11.0232 9.85873 9.78085 11.8583 9.70703 13.7162C9.70719 15.8398 11.4429 17.5755 13.5763 17.5755C15.7097 17.5755 17.4454 15.8398 17.4454 13.7064C17.3722 11.8586 16.1301 9.85921 13.5766 9.85889Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1446 14.0909C12.1444 14.5033 12.1447 15.3507 12.1446 15.7659L15.6358 13.6174L12.1446 11.6479V14.0909Z",
    fill: "#F1F1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 13.737,
    cy: 13.5412,
    r: 13.0019,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.07956
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtMusic);
export default __webpack_public_path__ + "static/media/Yt Music.e3f01f4242af64fdebe083e73f4cbff0.svg";
export { ForwardRef as ReactComponent };